module.exports = __webpack_public_path__ + "dimer/static/img/MrJsL.f08c524.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/MrJsL.jpg
// module id = bTj9
// module chunks = 0